import { render, staticRenderFns } from "./NovaPositionTransfer.vue?vue&type=template&id=e753e9c2&scoped=true&"
import script from "./NovaPositionTransfer.vue?vue&type=script&lang=ts&"
export * from "./NovaPositionTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./NovaPositionTransfer.vue?vue&type=style&index=0&id=e753e9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e753e9c2",
  null
  
)

export default component.exports